<template>
  <div>
    <v-data-table
      :headers="filteredHeaders"
      :items="all"
      :footer-props="{
        itemsPerPageText: 'Filas por página',
        itemsPerPageOptions: [10,20,30,50,100]
      }"
      :loading="loading"
      :options.sync="optionsLocal"
      :server-items-length="itemsLength"
      :items-per-page="10"
      disable-sort
      :item-class="rowClasses"
    >
      <template v-slot:top>
        <div class="d-flex align-center py-2 px-4">
          <v-spacer></v-spacer>
          <v-menu
            v-if="$can('transacciones.columnas')"
            offset-y
            :close-on-content-click="false"
            left
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="secondary"
                outlined
                v-bind="attrs"
                v-on="on"
                small
              >
                <v-icon left size="18">mdi-view-column</v-icon>
                Columnas
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="col in optionalColumns"
                :key="col.value"
                @click="toggleColumn(col.value)"
              >
                <v-list-item-action class="mr-3 my-0">
                  <v-checkbox
                    :input-value="visibleColumns.includes(col.value)"
                    color="primary"
                    hide-details
                    class="ma-0 pa-0"
                    readonly
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content class="py-1">
                  <v-list-item-title class="body-2">{{ col.text }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </template>
      <template v-slot:item.id="{ item }">
        <div
          @click="onSelect(item)"
          v-if="item.transaccion_tipo"
        >
          <v-btn icon>
            <v-icon color="error" v-if="item.transaccion_tipo === 'Debito'">mdi-circle</v-icon>
            <v-icon color="success" v-else>mdi-circle</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:item.fecha="{ item }">
        <div v-if="item.fecha">
          {{ item.fecha | moment('DD/MM/YYYY') }}
        </div>
      </template>
      <template v-slot:item.transaccion_detalle="{ item }">
        <div v-if="item.transaccion_detalle">
          {{ item.transaccion_detalle }}
        </div>
      </template>
      <template v-slot:item.cantidad="{ item }">
        <div v-if="item.coeficiente === 1">
          {{ parseFloat(item.cantidad) | formatToThreeDecimals }}
        </div>
        <div v-if="item.coeficiente > 1">
          {{ (parseFloat(item.cantidad) / parseInt(item.coeficiente)) | formatToThreeDecimals }}
        </div>
      </template>
      <template v-slot:item.importe="{ item }">
        <div v-if="!item.importe">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.importe) | formatToTwoDecimals }}
        </div>
      </template>
      <!-- <template v-slot:item.detalle_saldos="{ item }">
        <div v-if="!item.detalle_saldos">
          $ 0,00
        </div>
        <div v-else>
          $ {{ onDetalleSaldos(item.detalle_saldos) | formatToTwoDecimals }}
        </div>
      </template> -->
      <template v-slot:item.cuenta_saldo="{ item }">
        <div v-if="!item.cuenta_saldo">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.cuenta_saldo) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.cuenta_subsidio="{ item }">
        <div v-if="!item.cuenta_subsidio">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.cuenta_subsidio) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.detalle_saldos.usuario="{ item }">
        $ {{ parseFloat(item.detalle_saldos.usuario) | formatToTwoDecimals }}
      </template>
      <template v-slot:item.cuenta_usuario="{ item }">
        <div v-if="!item.cuenta_usuario">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.cuenta_usuario) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.detalle_saldos.subsidio="{ item }">
        <div v-if="!item.detalle_saldos.subsidio">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.detalle_saldos.subsidio) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.detalle_saldos.pleno="{ item }">
        <div v-if="!item.detalle_saldos.pleno">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.detalle_saldos.pleno) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:item.detalle_saldos.demas="{ item }">
        <div v-if="!item.detalle_saldos.demas">
          $ 0,00
        </div>
        <div v-else>
          $ {{ parseFloat(item.detalle_saldos.demas) | formatToTwoDecimals }}
        </div>
      </template>
      <template v-slot:no-data>
        <v-alert :value="true" color="warning" icon="mdi-alert">
          No hay información de transacciones para mostrar.
        </v-alert>
      </template>
      <template v-slot:pageText="props">
        Filas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
    <transacciones-edit v-model="dialogEdit" />
    <transacciones-listener />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PeriodoMixin from '@/mixins/Periodo'
import PrecioMixin from '@/mixins/Precios'
import ProductoMixin from '@/mixins/Productos'
import TransaccionesListener from '@/pages/transacciones/ListenerComponent'
import TransaccionesEdit from '@/pages/transacciones/EditComponent'
export default {
  data () {
    return {
      dialogEdit: false,
      transferColors: {
        background: '#FFE0B2',
        text: '#E65100'
      },
      optionalColumns: [
        { text: 'Deuda usuario', value: 'detalle_saldos.usuario' },
        { text: 'Subsidio a favor', value: 'detalle_saldos.subsidio' },
        { text: 'Deuda pleno', value: 'detalle_saldos.pleno' },
        { text: 'Dinero demás', value: 'detalle_saldos.demas' }
      ],
      visibleColumns: []
    }
  },
  name: 'TransaccionesDatatableComponent',
  mixins: [PeriodoMixin, PrecioMixin, ProductoMixin],
  components: {
    'transacciones-listener': TransaccionesListener,
    'transacciones-edit': TransaccionesEdit
  },
  created () {
    const saved = localStorage.getItem('transacciones_visible_columns')
    if (saved) {
      try {
        this.visibleColumns = JSON.parse(saved)
      } catch (e) {
        this.visibleColumns = []
      }
    } else {
      this.visibleColumns = []
    }
  },
  beforeDestroy () {
    this.onClearAll()
  },
  computed: {
    ...mapGetters('Transacciones', ['all', 'headers', 'loading', 'itemsLength', 'options', 'edited', 'filters']),
    optionsLocal: {
      get () {
        return this.options
      },
      set (value) {
        this.setOptions(value)
        if(this.filters && this.filters.cuenta_id > 0) {
          this.onFetch()
        }
      }
    },
    filteredHeaders () {
      return this.headers.filter(header => {
        const fixedValues = ['id', 'fecha', 'transaccion_detalle', 'cantidad', 'importe']
        if (fixedValues.includes(header.value)) {
          return true
        }
        return this.$can('transacciones.columnas') && this.visibleColumns.includes(header.value)
      })
    }
  },
  methods: {
    rowClasses(item) {
      if (item.transferencia_origen || (item.transferencias_destinos && item.transferencias_destinos.length > 0)) {
        return 'orange lighten-5'
      }
      // else if (item.transaccion_tipo === 'Debito' && this.$moment().diff(this.$moment(item.fecha), 'days') >= 60 && item.saldo < 0 && item.diferencia_destino.length == 0) {
      //   return 'red lighten-5'
      // } else if (item.transaccion_tipo === 'Debito' && item.saldo < 0) {
      //   return 'orange lighten-5'
      // } else if (item.transaccion_tipo !== 'Debito' && item.saldo > 0) {
      //   return 'green lighten-5'
      // }
      return ''
    },
    ...mapActions('Transacciones', ['onClearAll', 'onFetch']),
    ...mapMutations('Transacciones', ['setEdited', 'setSelected', 'setOptions', 'setFilters']),
    async onSelect (item) {
      /* Se cargan los datos en la variable Seleccionado para comparar */
      const aux = {
        ...this.edited,
        id: item.id,
        transaccion_tipo: item.transaccion_tipo,
        transaccion_detalle: item.transaccion_detalle,
        glosas: item.glosas,
        fecha: item.fecha,
        cantidad: item.cantidad,
        coeficiente: item.coeficiente,
        importe: item.importe,
        saldo: item.saldo,
        detalle_saldos: item.detalle_saldos,
        imputaciones: item.imputaciones,
        cuenta_id: item.cuenta_id,
        transferencia_origen: item.transferencia_origen,
        transferencias_destinos: item.transferencias_destinos,
        recibo_id: item.recibo_id,
        recibo_numero: item.recibo_numero,
        cambio: item.cambio,
        desglose_pagos: item.desglose_pagos,
        created_at: item.created_at,
        updated_at: item.updated_at,
        deleted_at: item.deleted_at,
        autor: item.autor
      }
      await this.setEdited(aux)
      await this.setSelected(aux)
      this.dialogEdit = true
      // this.$emit('update:selected', true)
    },
    onDetalleSaldos(item) {
      if(item == null) return 0;
      return item.demas - item.pleno - item.usuario;
    },
    toggleColumn (value) {
      const index = this.visibleColumns.indexOf(value)
      if (index === -1) {
        this.visibleColumns.push(value)
      } else {
        this.visibleColumns.splice(index, 1)
      }
      this.saveVisibleColumns()
    },
    saveVisibleColumns () {
      localStorage.setItem('transacciones_visible_columns', JSON.stringify(this.visibleColumns))
    }
  }
}
</script>
